/* eslint-disable simple-import-sort/imports */
// The order of these imports is important to avoid circular dependencies
import "./tiptap-main.css";    // Main container styles
import "./tiptap-toolbar.css"; // Editor toolbar styles
import "./tiptap-content.css"; // Content styles for rendered text

import { applyTextFormat, detectCurrentFormat } from "./helpers";
import MenuButton from "./MenuButton";
import EditorToolbar from "./EditorToolbar";
import EditorContent from "./EditorContent";
import TiptapEditor from "./TiptapEditor";

export default TiptapEditor;

export {
	applyTextFormat,
	detectCurrentFormat,
	EditorContent,
	EditorToolbar,
	MenuButton,
	TiptapEditor
};